export const participantFilterType = {
  none: 'NONE',
  raisedHands: 'RAISED_HANDS',
  unmuted: 'UNMUTED'
};
